import dayjs from 'dayjs';

// 生成随机数据
const generateRandomData = () => {
  const categories = ['生活随笔', '技术笔记', '读书心得', '旅行见闻', '美食分享', '摄影', '设计'];
  const tags = ['前端', 'React', 'JavaScript', 'CSS', 'Node.js', '生活', '思考', '旅行', '美食', '读书', '摄影', '设计'];
  const authors = ['小明', '小红', '小华', '小李', '小王'];
  
  const posts = [];
  
  // 生成近30天的文章
  for (let i = 0; i < 30; i++) {
    const category = categories[Math.floor(Math.random() * categories.length)];
    const author = authors[Math.floor(Math.random() * authors.length)];
    const date = dayjs().subtract(Math.floor(Math.random() * 30), 'day').format('YYYY-MM-DD');
    
    // 生成3-5个随机标签
    const postTags = [];
    const tagCount = 3 + Math.floor(Math.random() * 3);
    for (let j = 0; j < tagCount; j++) {
      const tag = tags[Math.floor(Math.random() * tags.length)];
      if (!postTags.includes(tag)) {
        postTags.push(tag);
      }
    }
    
    posts.push({
      id: i + 1,
      title: getRandomTitle(category, i),
      content: getRandomContent(category),
      excerpt: getRandomExcerpt(category),
      category,
      tags: postTags,
      author,
      date,
      views: Math.floor(Math.random() * 1000) + 100,
      comments: Math.floor(Math.random() * 50),
      likes: Math.floor(Math.random() * 200) + 50,
      image: `https://picsum.photos/600/400?random=${i + 1}`,
      isPublished: true
    });
  }
  
  return posts;
};

// 生成随机标题
const getRandomTitle = (category, index) => {
  const titles = {
    '生活随笔': [
      '大二碎记：在校园的烟火里，捡拾成长的星光',
      '午后咖啡厅的随想',
      '一个人的城市漫步',
      '那些被遗忘的日常美好',
      '深夜书桌前的思考'
    ],
    '技术笔记': [
      'React 19 新特性深度解析',
      'JavaScript 设计模式实践',
      'CSS Grid 布局完全指南',
      '前端性能优化实战',
      'TypeScript 进阶技巧'
    ],
    '读书心得': [
      '《活着》读后感：生命的重量',
      '重读《小王子》的感悟',
      '《百年孤独》中的魔幻与现实',
      '《原则》中的生活与工作智慧',
      '《人类简史》带给我的思考'
    ],
    '旅行见闻': [
      '武汉美食打卡全攻略：在烟火气里吃透江湖味',
      '西藏之行：心灵的洗礼',
      '厦门鼓浪屿的文艺时光',
      '西安古城墙下的历史回响',
      '云南大理的风花雪月'
    ],
    '美食分享': [
      '家庭版火锅制作全攻略',
      '烘焙新手的第一份蛋糕',
      '五分钟快手早餐合集',
      '地方特色小吃探店',
      '健康减脂餐制作心得'
    ],
    '摄影': [
      '手机摄影技巧分享',
      '光影的艺术：人像摄影心得',
      '城市建筑摄影构图技巧',
      '自然风光拍摄注意事项',
      '后期调色思路分享'
    ],
    '设计': [
      'UI设计中的色彩心理学',
      '用户体验设计原则',
      '平面设计中的留白艺术',
      '响应式设计最佳实践',
      '设计思维在工作中的应用'
    ]
  };
  
  const categoryTitles = titles[category] || titles['生活随笔'];
  return categoryTitles[index % categoryTitles.length];
};

// 生成随机内容
const getRandomContent = (category) => {
  const paragraphs = [
    `这是一篇关于${category}的文章。在这个快速发展的时代，我们需要不断地学习和思考。`,
    
    `最近我在${category}方面有了一些新的感悟。生活中的每一个细节都值得我们去关注和记录。`,
    
    `通过这段时间的实践和思考，我发现在${category}领域有很多值得探索的方向。`,
    
    `或许每个人对${category}的理解都不同，但正是这种多样性让我们的世界更加精彩。`,
    
    `在未来的日子里，我希望能够继续在${category}方面深入探索，并与大家分享更多有价值的内容。`,
    
    `无论是工作还是生活，${category}都扮演着重要的角色。我们需要用心去感受和体验。`,
    
    `这篇文章只是我对${category}的一些粗浅见解，希望能给大家带来一些启发和思考。`,
    
    `让我们一起探索${category}的奥秘，发现生活中的美好和智慧。`
  ];
  
  // 随机选择5-8段
  const paragraphCount = 5 + Math.floor(Math.random() * 4);
  const selectedParagraphs = [];
  
  for (let i = 0; i < paragraphCount; i++) {
    selectedParagraphs.push(paragraphs[Math.floor(Math.random() * paragraphs.length)]);
  }
  
  return selectedParagraphs.join('\n\n');
};

// 生成随机摘要
const getRandomExcerpt = (category) => {
  const excerpts = [
    `探索${category}的精彩世界，分享我的学习和思考`,
    `记录我在${category}方面的经验和心得`,
    `从不同角度看待${category}，发现新的可能性`,
    `在${category}的道路上不断前行，收获成长与感悟`,
    `分享${category}带给我的快乐和启发`,
    `深入探讨${category}的各个方面，提供实用的建议`,
    `记录${category}中的美好瞬间和深刻思考`
  ];
  
  return excerpts[Math.floor(Math.random() * excerpts.length)];
};

// 生成用户数据
// 生成用户数据
export const generateUsers = () => {
  return [
    {
      id: 1,
      username: 'admin',
      email: 'admin@example.com',
      password: '123456',
      avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=admin&backgroundColor=0D8ABC',
      bio: '热爱生活，喜欢分享的程序员',
      techStack: ['React', 'Node.js', 'TypeScript'],
      interests: ['编程', '读书', '旅行'],
      github: 'https://github.com/admin',
      twitter: 'https://twitter.com/admin',
      website: 'https://example.com',
      role: 'admin',
      createdAt: '2024-01-01'
    },
    {
      id: 2,
      username: '小明',
      email: 'xiaoming@example.com',
      password: '123456',
      avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=xiaoming&backgroundColor=0D8ABC',
      bio: '一个普通的学生，喜欢记录生活',
      techStack: ['Python', 'Java'],
      interests: ['篮球', '音乐', '电影'],
      github: 'https://github.com/xiaoming',
      twitter: '',
      website: '',
      role: 'user',
      createdAt: '2024-01-10'
    },
    {
      id: 3,
      username: '小红',
      email: 'xiaohong@example.com',
      password: '123456',
      avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=xiaohong&backgroundColor=FF6B6B',
      bio: '美食爱好者，喜欢分享探店心得',
      techStack: [],
      interests: ['美食', '旅行', '摄影'],
      github: '',
      twitter: 'https://twitter.com/xiaohong',
      website: '',
      role: 'user',
      createdAt: '2024-01-15'
    },
    {
      id: 4,
      username: '小华',
      email: 'xiaohua@example.com',
      password: '123456',
      avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=xiaohua&backgroundColor=4ECDC4', 
      bio: '读书爱好者，喜欢写作和分享读后感',
      techStack: ['Vue.js', 'JavaScript'],
      interests: ['读书', '写作', '瑜伽'],
      github: 'https://github.com/xiaohua',
      twitter: '',
      website: 'https://xiaohua.blog.com',
      role: 'user',
      createdAt: '2024-01-20'
    }
  ];
};

// 生成评论数据
const generateComments = (posts) => {
  const comments = [];
  const users = ['访客A', '访客B', '访客C', '小明', '小红', '小华'];
  
  posts.forEach(post => {
    const commentCount = Math.floor(Math.random() * 10) + 1;
    
    for (let i = 0; i < commentCount; i++) {
      comments.push({
        id: comments.length + 1,
        postId: post.id,
        author: users[Math.floor(Math.random() * users.length)],
        content: getRandomComment(),
        date: dayjs(post.date).add(Math.floor(Math.random() * 5), 'day').format('YYYY-MM-DD'),
        likes: Math.floor(Math.random() * 20)
      });
    }
  });
  
  return comments;
};

// 生成随机评论
const getRandomComment = () => {
  const comments = [
    '写得很棒！收获很多！',
    '期待更多这样的好文章',
    '作者的观点很有启发性',
    '学习了，谢谢分享',
    '文章内容很实用，已收藏',
    '赞同作者的观点',
    '有不同看法，欢迎讨论',
    '希望能看到更多关于这个主题的内容',
    '文章结构清晰，逻辑严谨',
    '受益匪浅，感谢作者'
  ];
  
  return comments[Math.floor(Math.random() * comments.length)];
};

// 导出模拟数据
export const mockPosts = generateRandomData();
export const mockUsers = generateUsers();
export const mockComments = generateComments(mockPosts);

// API 函数
export const getPosts = () => {
  return [...mockPosts].sort((a, b) => new Date(b.date) - new Date(a.date));
};

export const getPostById = (id) => {
  return mockPosts.find(post => post.id === parseInt(id));
};

export const getPostsByCategory = (category) => {
  return mockPosts.filter(post => post.category === category);
};

export const getPostsByTag = (tag) => {
  return mockPosts.filter(post => post.tags.includes(tag));
};

export const getPostsByAuthor = (author) => {
  return mockPosts.filter(post => post.author === author);
};

export const getUserByUsername = (username) => {
  return mockUsers.find(user => user.username === username);
};

export const getCommentsByPostId = (postId) => {
  return mockComments.filter(comment => comment.postId === parseInt(postId));
};

// 保存文章到本地存储
export const savePost = (post) => {
  const posts = JSON.parse(localStorage.getItem('blog_posts') || '[]');
  posts.unshift(post);
  localStorage.setItem('blog_posts', JSON.stringify(posts));
  return post;
};

// 更新文章
export const updatePost = (id, postData) => {
  const posts = JSON.parse(localStorage.getItem('blog_posts') || '[]');
  const index = posts.findIndex(post => post.id === parseInt(id));
  if (index !== -1) {
    posts[index] = { ...posts[index], ...postData };
    localStorage.setItem('blog_posts', JSON.stringify(posts));
    return posts[index];
  }
  return null;
};

// 删除文章
export const deletePost = (id) => {
  const posts = JSON.parse(localStorage.getItem('blog_posts') || '[]');
  const filteredPosts = posts.filter(post => post.id !== parseInt(id));
  localStorage.setItem('blog_posts', JSON.stringify(filteredPosts));
  return true;
};

// 模拟延迟
export const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));